import { CLIENTBUILDREQUIREMENT } from "../ENVIRONMENT";

async function postBuildRequirementAcademic(token, data,id) {
  // api for submit client buildrequirement academic 
  return await fetch(CLIENTBUILDREQUIREMENT+`/${id}/academic`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
       "Authorization": `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
    body: JSON.stringify(data),
  });
}

export { postBuildRequirementAcademic };
